import { AfterViewInit, Input, Component, ElementRef, ViewChild, Output, EventEmitter, Inject } from '@angular/core';
import * as ForceGraph3D from '3d-force-graph';
import { Edge, Node } from 'vis-network';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface Node3D {
  id: number | string;
  name?: string;
  val?: number;
  color?: string;
}

interface Link3D {
  source: number | string;
  target: number | string;
  group: number;
}

interface NodeGetted extends Node {
  raw: any;
}

@Component({
  selector: 'app-force-graph',
  template: `
    <div #graph3dContainer></div>
    <button mat-button class="btn btn-info" (click)="onVolverClick()" style="background: #110c2a !important;">2D</button>
  `,
  styleUrls: ['./force-graph.component.css'],
})
export class ForceGraphComponent implements AfterViewInit {
  @ViewChild('graph3dContainer', { static: true }) graphContainer!: ElementRef;
  @Output() volver = new EventEmitter<boolean>();
  @Input() nodes: NodeGetted[] = [];
  @Input() links: Edge[] = [];
  private g3D!: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ForceGraphComponent>
  ) { 
    if(data.nodes && data.links) {
      this.nodes = data.nodes;
      this.links = data.links;
    }
  }
  onVolverClick() {
    this.volver.emit(true);
    this.dialogRef.close();
  }
  transformLinksNeo4jTo3d(links: Edge[]): Link3D[] {
    return links.map(link => {
      return {
        source: link.from,
        target: link.to,
        group: 1
      }
    })
  }

  transformNodestoNodes3d(nodes: NodeGetted[]): Node3D[] {
    return nodes.map(node => {
      return {
        id: node.id,
        name: node.label,
        val: this.getGroupFromLabel(node.raw.labels['0']),
        color: this.getColorFromLabel(node.raw.labels['0'])
      }
    })
  }

  getGroupFromLabel(label: string): number {
    switch (label) {
      case 'Customer':
        return 1;
      case 'Account':
        return 2;
      default:
        return 0;
    }
  }

  getColorFromLabel(label: string): string {
    switch (label) {
      case 'Customer':
        return '#FF0000';
      case 'Account':
        return '#FFFF33';
      default:
        return '#FFFF';
    }
  }

  ngAfterViewInit() {
    console.log("Nodes", this.nodes)
    console.log("Edges", this.links)
    console.log("this.graphContainer", this.graphContainer)
    this.g3D = ForceGraph3D()(this.graphContainer.nativeElement)
      .graphData({ nodes: this.transformNodestoNodes3d(this.nodes), links: this.transformLinksNeo4jTo3d(this.links) })
      .nodeAutoColorBy('group')
      .linkColor(() => '#999')
      .linkOpacity(0.5)
      .linkWidth(2)
  }

}